import { Button, Typography, ScreenContainer, ContentFrame, LayoutContent, LayoutControls, } from '@pinwheel/origami';
import React from 'react';
import { useParams } from 'react-router';
import CircledBangImage from '../../components/CircledBangImage';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import ModalHeader from '../../components/ModalHeader';
import DocumentUploadsFileUploadButton from '../../components/DocumentUploads/DocumentUploadsFileUploadButton';
import { selectStagedDocumentById, unstageDocument, } from '../../state/slices/slice-document-uploads';
import { useAppDispatch, useAppSelector } from '../../state';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useDocumentUploadsErrorText } from '../../hooks/useDocumentUploadsErrorText';
var DocumentUploadsRepair = function () {
    var getLocalizedString = useGetLocalizedString();
    var fileId = useParams().fileId;
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var toRepair = useAppSelector(function (state) {
        return selectStagedDocumentById(state, fileId);
    });
    var _a = useDocumentUploadsErrorText(toRepair), errorTitle = _a.errorTitle, errorDescription = _a.errorDescription;
    return (React.createElement(ScreenContainer, { "data-testid": "DocumentUploads-repair" },
        React.createElement(ModalHeader, { title: toRepair === null || toRepair === void 0 ? void 0 : toRepair.name, clampTitleText: true }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }, "data-testid": "DocumentUploads-repair" },
                    React.createElement(CircledBangImage, null),
                    React.createElement(Typography, { sx: { margin: '16px 0' }, variant: "header", as: "h2" }, errorTitle),
                    React.createElement(Typography, { variant: "body" }, errorDescription))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { variant: "outline", eventId: "delete", dataTestId: "button", onClick: function () {
                        // Param types in react-router can be undefined, although this
                        // should never happen in practice.
                        if (fileId != null) {
                            dispatch(unstageDocument(fileId));
                        }
                        navigate(-1);
                    } }, getLocalizedString('REMOVE_FROM_LIST')),
                React.createElement(DocumentUploadsFileUploadButton, { customOrExistingDocumentId: fileId, eventId: "select-different-document", dataTestId: "button", 
                    // Only allow a single file since we're replacing the previous file
                    multiple: false, onFilesAdded: function () {
                        navigate(-1);
                    } }, getLocalizedString('TRY_AGAIN'))))));
};
export default DocumentUploadsRepair;
